module.exports = __webpack_public_path__ + "media/ss_photos/ss-overview-photo-03-fb8e0fe3.webp";